/* Utils */
import MobileDetect from 'mobile-detect';
import Features from 'Features';
import {
	fromUnixTime, format
} from 'date-fns';

const md = new MobileDetect(window.navigator.userAgent);

export default {
	delay: timer => new Promise(resolve => setTimeout(resolve, timer)),

	// Return the feature status (true:enabled, false: disabled)
	isEnabled(featureName) {
		if (Object.keys(Features).find(key => key === featureName)) {
			return Features[featureName].indexOf(ENV) > -1;
		}
		return false;
	},

	updateObject: (oldObject, updatedProperties) => ({
		...oldObject,
		...updatedProperties
	}),

	mergeArray: (oldA, newA, field) => oldA
		.concat(newA.filter(item => oldA.findIndex(element => element[field] === item[field]) < 0))
		.sort((a, b) => a.x - b.x),

	ellipsisText(text, maxLength = 20) {
		if (text.length <= maxLength) {
			return text;
		}

		return `${text.substring(0, maxLength)}...`;
	},

	/* Detect browser */
	isMobile: () => md.mobile() !== null,
	isPlatform: platform => md.os() === platform,

	/* Validate email */
	isValidEmail: (email) => {
		const rgx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return rgx.test(String(email).toLowerCase());
	},

	/* Validate Password */
	isValidPassword: password => password.length > 4,

	/* Get today date for input placeholders */
	getTodayDate() {
		return format(new Date(), 'yyyy-MM-dd');
	},

	/* Convert and display date */
	displayDate(date) {
		return format(fromUnixTime(date), 'dd/MM/yyyy');
	},

	/* Get current time HH:MM for input placeholders */
	getCurrentTime() {
		return format(new Date(), 'kk:mm');
	},

	/**
	* @param {string} => "string".
	* Return "String"
	*/
	capitalizeFirstLetter: (str) => str.charAt(0).toUpperCase() + str.slice(1),

	getOrderNumber: ({ source, order_number: orderNumber }) => {
		const squarespaceNumber = orderNumber.toString().padStart(5, '0');
		return `${source === 'squarespace' ? squarespaceNumber : orderNumber}`;
	},

	decodeHtmlEntities: (encodedString) => {
		const translateRegex = /&(nbsp|amp|quot|lt|gt|eacute|icirc);/g;
		const translate = {
			nbsp: ' ',
			amp: '&',
			quot: '"',
			lt: '<',
			gt: '>',
			eacute: 'é',
			icirc: 'î'

		};

		if (!encodedString) return '';

		return encodedString
			.replace(translateRegex, (match, entity) => translate[entity])
			.replace(/&#(\d+);/gi, (match, numStr) => {
				const num = parseInt(numStr, 10);
				return String.fromCharCode(num);
			});
	},

	orderNotFinished: status => status !== 'canceled' && status !== 'sent'
};
